import { useMemo } from "react"
import { RefreshableError } from "../helpers/errors"
import { useAiTeammateContext } from "./ai-teammate-context"
import { useMessagesContext } from "./messages-context"

export function useShouldDisableUserInput() {
  const { error } = useAiTeammateContext()
  const { isFetching, isFetchingNextPage, isSendingMessage } = useMessagesContext()
  const isRefreshableError = error instanceof RefreshableError

  return useMemo(() => {
    return (isFetching && !isFetchingNextPage) || isSendingMessage || isRefreshableError
  }, [isFetching, isFetchingNextPage, isSendingMessage, isRefreshableError])
}
